import { Dictionary } from "flow/api/types";
import service from "flow/data/service";
import { HomeConfig } from "flow/entities/HomeConfig";
import type MyFlow from "flow/MyFlow";
import manifestManager from "flow/utils/manifestManager";

let sortOrder: Dictionary<number> = {};
let blacklist: string[] = [];
let whitelist: string[] = [];

export function save(myFlow: MyFlow, productId: string, config: HomeConfig) {
    return service.updateHomeConfig(myFlow, productId, config);
}

export function reset(myFlow: MyFlow, productId: string) {
    return service.resetHomeConfig(myFlow, productId).then(() => {
        sortOrder = {};
        blacklist = [];
        whitelist = [];
    });
}

export function loadFromServer(myFlow: MyFlow, productId: string) {
    return service.getHomeConfig(myFlow, productId).then(loadFromObject);
}

export function loadFromObject(config: HomeConfig) {
    sortOrder = config?.sortOrder || {};
    blacklist = config?.blacklist || [];
    whitelist = config?.whitelist || [];
}

export function isHidden(id: string) {
    if (blacklist.includes(id)) {
        return true;
    }

    const manifest = manifestManager.getManifestWithId(id);

    if (!manifest || !manifest.defaultHidden) {
        return false;
    }

    // Hidden by default, will only show if whitelisted.
    return !whitelist.includes(id);
}

export function getSortOrder(id: string, defaultOrder: number) {
    return sortOrder[id] ?? defaultOrder;
}
